import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import adobeTags from 'src/types/adobe-tags';
import styles from './transactionNameAccount.module.scss';
import { DlsTypographyVariants } from 'src/types/dls-typography-variants.enum';
import Selectors from 'src/utils/selectors';
import AccountService from 'src/services/account.service';
import React from 'react';
import { useLocation } from 'react-router-dom';
import FormatService from 'src/services/format.service';
import DateUtils from 'src/utils/date';
import { useVisibleAccounts } from 'src/hooks/queries/accounts';
import { AccountModel } from 'src/types/account.model';
import { find } from 'lodash';
import { LocalDate } from '@js-joda/core';
import { useHistory } from 'react-router';
import { getTransactionDetailsUrl, goToTransactionDetails } from 'src/services/router.service';
import useCurrentUser from 'src/hooks/useCurrentUser';

interface Props {
    accountId: number;
    transactionId: number;
    transactionDisplayName: string;
    transactionDate: LocalDate;
    merchantName: string;
}

export default function TransactionNameAccount({
    accountId,
    transactionId,
    transactionDisplayName,
    transactionDate,
    merchantName
}: Props): JSX.Element {
    const { pathname, search } = useLocation();
    const history = useHistory();
    const { isFullPlanUser } = useCurrentUser();
    const { data: accounts } = useVisibleAccounts();
    const account: AccountModel = find(accounts, { id: accountId });

    const handleOpenTransactionDetails = (): void => {
        const scrollContainer: HTMLElement = document.getElementById('scrollContainer');
        const scrollPosition: number = scrollContainer.scrollTop;
        if (scrollPosition) {
            const searchParams: URLSearchParams = new URLSearchParams(search);
            searchParams.set('scrollPosition', scrollPosition.toString());
            history.replace(`${pathname}?${searchParams.toString()}`);
        }
        goToTransactionDetails(transactionId, isFullPlanUser, history, { from: pathname, search });
    };

    const date: string = FormatService.formatDate(DateUtils.fromDateToLocalDate(transactionDate.toString()));

    return (
        <div>
            <Anchor
                onClick={handleOpenTransactionDetails}
                tag={adobeTags.Transactions.Row.ViewDetails}
                href={getTransactionDetailsUrl(transactionId)}
                className={`${styles.nameLink} ${DlsTypographyVariants.BODY_2}`}
                aria-label={`${date} ${transactionDisplayName}`}
                data-cy={Selectors.Transactions.NAME_VALUE}
            >
                {transactionDisplayName}
            </Anchor>
            <p className={DlsTypographyVariants.LEGAL_1}>{merchantName}</p>
            <p className={DlsTypographyVariants.LEGAL_1}>{AccountService.getDisplayName(account)}</p>
        </div>
    );
}
